﻿import {VehicleId} from "../../nominalTypes/VehicleId";
import {CreateVehicleArguments} from "../../types/arguments/CreateVehicleArguments";
import {UpdateEntityAttachmentArguments} from "../../types/arguments/UpdateEntityAttachmentArguments";
import {CustomDataEntry} from "../../types/CustomDataEntry";
import {VehicleData} from "../../types/VehicleData";
import IPermitsVehicles from "../IPermitsVehicles";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsVehicles implements IPermitsVehicles {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	hide(vehicleId: VehicleId, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch(`vehicles/${vehicleId}/hide`, "PUT", null, {
			signal: signal
		});
	}

	create(data: CreateVehicleArguments, signal?: AbortSignal | undefined): Promise<VehicleId> {
		return this._client.jsonFetch("vehicles", "POST", data, {
			signal: signal
		});
	}

	mergeCustomData(vehicleId: VehicleId, data: CustomDataEntry[], signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch(`vehicles/${vehicleId}/custom-data`, "PUT", data, {
			signal: signal
		});
	}

	update(vehicleId: VehicleId, data: VehicleData, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch(`vehicles/${vehicleId}`, "PUT", data, {
			signal: signal
		});
	}

	public updateAttachments(vehicleId: VehicleId, data: UpdateEntityAttachmentArguments, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch(`vehicles/${vehicleId}/attachments`, "PUT", data, {
			signal: signal
		});
	}
}
